/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateTevredenheidDto } from '../models/create-tevredenheid-dto';
import { TevredenheidSubmitDto } from '../models/tevredenheid-submit-dto';
import { TevredenheidsmeterCategorieDto } from '../models/tevredenheidsmeter-categorie-dto';

@Injectable({
  providedIn: 'root',
})
export class TevredenheidsApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createTevredenheid
   */
  static readonly CreateTevredenheidPath = '/api/extern/tegelclick/create-tevredenheid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTevredenheid$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTevredenheid$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: CreateTevredenheidDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TevredenheidsApiService.CreateTevredenheidPath, 'post');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTevredenheid$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTevredenheid$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: CreateTevredenheidDto
  }): Observable<number> {

    return this.createTevredenheid$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTevredenheid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTevredenheid$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: CreateTevredenheidDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TevredenheidsApiService.CreateTevredenheidPath, 'post');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTevredenheid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createTevredenheid(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: CreateTevredenheidDto
  }): Observable<number> {

    return this.createTevredenheid$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation submitTevredenheid
   */
  static readonly SubmitTevredenheidPath = '/api/extern/tegelclick/submit-tevredenheid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitTevredenheid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  submitTevredenheid$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: TevredenheidSubmitDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TevredenheidsApiService.SubmitTevredenheidPath, 'post');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `submitTevredenheid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  submitTevredenheid(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
    body?: TevredenheidSubmitDto
  }): Observable<void> {

    return this.submitTevredenheid$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getTevredenheidsCategorien
   */
  static readonly GetTevredenheidsCategorienPath = '/api/extern/tegelclick/get-tevredenheid-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTevredenheidsCategorien$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTevredenheidsCategorien$Plain$Response(params?: {
    toepassingsCode?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<TevredenheidsmeterCategorieDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TevredenheidsApiService.GetTevredenheidsCategorienPath, 'get');
    if (params) {
      rb.query('toepassingsCode', params.toepassingsCode, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TevredenheidsmeterCategorieDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTevredenheidsCategorien$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTevredenheidsCategorien$Plain(params?: {
    toepassingsCode?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<TevredenheidsmeterCategorieDto>> {

    return this.getTevredenheidsCategorien$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TevredenheidsmeterCategorieDto>>) => r.body as Array<TevredenheidsmeterCategorieDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTevredenheidsCategorien()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTevredenheidsCategorien$Response(params?: {
    toepassingsCode?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<TevredenheidsmeterCategorieDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TevredenheidsApiService.GetTevredenheidsCategorienPath, 'get');
    if (params) {
      rb.query('toepassingsCode', params.toepassingsCode, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TevredenheidsmeterCategorieDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTevredenheidsCategorien$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTevredenheidsCategorien(params?: {
    toepassingsCode?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<TevredenheidsmeterCategorieDto>> {

    return this.getTevredenheidsCategorien$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TevredenheidsmeterCategorieDto>>) => r.body as Array<TevredenheidsmeterCategorieDto>)
    );
  }

}
